import type { ReactNode } from 'react';

export interface ChartLegendLine {
  label: string;
  color: string;
  /** SVG dash of the line, e.g. the previous period's (`undefined` = solid). */
  dash?: string;
}

/** Dash of the previous period's line (ANLT-04), unlike the partial one. */
export const PREVIOUS_PERIOD_DASH = '2 3';

/** Legend items of extra lines (previous period, site ticket). */
export function ChartLegendLines({ lines }: { lines: ChartLegendLine[] }) {
  return (
    <>
      {lines.map((line) => (
        <span
          key={line.label}
          data-chart-legend-line
          className="flex items-center gap-1.5 pt-2 text-xs text-muted-foreground"
        >
          <svg width="16" height="10" aria-hidden="true">
            <line
              x1={0}
              y1={5}
              x2={16}
              y2={5}
              stroke={line.color}
              strokeWidth={2}
              strokeDasharray={line.dash}
            />
          </svg>
          {line.label}
        </span>
      ))}
    </>
  );
}

/** Row of legend items; ignores the props recharts' `Legend` passes in. */
export function ChartLegendRow({ children }: { children: ReactNode }) {
  return <div className="flex flex-wrap items-center gap-x-4">{children}</div>;
}
